module.exports = __webpack_public_path__ + "static/media/toolbar-search.61f85872.svg";